import { currencyFormat } from '@/helpers/currency-format'
const svgDottedLine =
	'<svg width="300px" height="84px" viewBox="0 0 300 84"><line x1="40" x2="260" y1="42" y2="42" stroke="#003e51" stroke-width="10" stroke-linecap="round" stroke-dasharray="1, 24"/></svg>'

const dottedLine = {
	svg: svgDottedLine,
	alignment: 'center',
}

const calcList = []

const client = {
	company: '',
	name: '',
}

const user = {
	name: '',
	email: '',
	avatar: '',
	phone: '',
	obs: '',
}

function addCalc(calc) {
	calcList.push(calc)
}

function clearCalcs() {
	calcList.length = 0
}

function clear() {
	clearCalcs()
}

function dotIcon(color = '#030104') {
	const svgDotIcon =
		'<svg height="15px" width="15px" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 31.955 31.955" xml:space="preserve"><g><path style="fill:' +
		color +
		'; " d="M27.25,4.655C20.996-1.571,10.88-1.546,4.656,4.706C-1.571,10.96-1.548,21.076,4.705,27.3 c6.256,6.226,16.374,6.203,22.597-0.051C33.526,20.995,33.505,10.878,27.25,4.655z"/><path style="fill:' +
		color +
		';" d="M13.288,23.896l-1.768,5.207c2.567,0.829,5.331,0.886,7.926,0.17l-0.665-5.416 C17.01,24.487,15.067,24.5,13.288,23.896z M8.12,13.122l-5.645-0.859c-0.741,2.666-0.666,5.514,0.225,8.143l5.491-1.375 C7.452,17.138,7.426,15.029,8.12,13.122z M28.763,11.333l-4.965,1.675c0.798,2.106,0.716,4.468-0.247,6.522l5.351,0.672 C29.827,17.319,29.78,14.193,28.763,11.333z M11.394,2.883l1.018,5.528c2.027-0.954,4.356-1.05,6.442-0.288l1.583-5.137 C17.523,1.94,14.328,1.906,11.394,2.883z"/><circle style="fill:' +
		color +
		';" cx="15.979" cy="15.977" r="6.117"/></g></svg>'

	return {
		svg: svgDotIcon,
		width: 15,
		margin: [0, 8, 0, 0],
	}
}

function clone(obj) {
	return Object.assign({}, obj)
}

function getCalcTitle(title, color, colSpan) {
	const row = []
	row.push({
		columns: [
			dotIcon(color),
			{ text: title, fontSize: 23, margin: [10, 0, 10, 0] },
		],
		colSpan: colSpan,
	})

	for (let i = 0; i < colSpan - 1; i++) {
		row.push(null)
	}

	return row
}

function getField(label, value, colSpan = 1, labelStyle = 'label') {
	return {
		stack: [
			{ text: label, style: labelStyle },
			{ text: value, style: 'value' },
		],
		colSpan,
	}
}

// exemplo fields: [{ label: 'Folha Mensal', value: 'R$100.000,00', colSpan: 1, labelStyle: 'labelHeader' }, { label: 'Alíquota', value: '5.8%', colSpan: 1, labelStyle: 'labelHeader'}]
function getCalcRow(fields, columns = 0) {
	const row = []
	fields.forEach((field) => {
		row.push(
			getField(
				field.label,
				field.value,
				field.colSpan || 1,
				field.labelStyle,
			),
		)
	})

	for (let i = row.length; i < columns; i++) {
		row.push(null)
	}

	return row
}

// { title: 'Serviços Hospitalares', columns: 3, color: '#ff5c74', rows: [fields, fields]}
function getCalc(calc) {
	const calcTemplate = {
		style: 'tableExample',
		table: {
			headerRows: 1,
			keepWithHeaderRows: 1,
			dontBreakRows: true,
			widths: '*',
			body: [],
		},
		layout: {
			paddingBottom: function () {
				return 12
			},
			hLineWidth: function () {
				return 0
			},
			vLineWidth: function () {
				return 0
			},
		},
	}

	calcTemplate.table.body.push(
		getCalcTitle(calc.title, calc.color, calc.columns),
	)
	calc.rows.forEach((fields) => {
		calcTemplate.table.body.push(getCalcRow(fields, calc.columns))
	})

	return calcTemplate
}

function getGridList() {
	const list = []
	calcList.forEach((calc) => {
		if (calc.type !== 'grid') {
			return
		}

		list.push(getCalc(calc))
	})

	return list
}

function getTable() {
	const tableTemplate = {
		style: 'tableExample',
		table: {
			headerRows: 1,
			keepWithHeaderRows: 1,
			dontBreakRows: true,
			widths: ['61%', '20%', '19%'],
			body: [
				[
					{ text: 'Tese', style: 'tableHeader' },
					{
						text: 'Economia Mensal',
						style: 'tableHeader',
						alignment: 'right',
					},
					{
						text: 'Recuperação',
						style: 'tableHeader',
						alignment: 'right',
					},
				],
			],
		},
		layout: {
			paddingLeft: function () {
				return 10
			},
			paddingTop: function () {
				return 5
			},
			paddingRight: function () {
				return 10
			},
			paddingBottom: function () {
				return 5
			},
			hLineWidth: function () {
				return 0
			},
			vLineWidth: function () {
				return 0
			},
			fillColor: function (rowIndex, node, columnIndex) {
				return rowIndex % 2 === 0 ? '#d9dde4' : '#E9EDF4'
			},
		},
	}

	const totalSavings = calcList.reduce(function (sum, calc) {
		if (calc.type !== 'table') return sum
		return (
			sum +
			parseFloat(calc.savings.replaceAll('.', '').replaceAll(',', '.'))
		)
	}, 0)

	const total = calcList.reduce(function (sum, calc) {
		if (calc.type !== 'table') return sum
		return (
			sum +
			parseFloat(calc.recuperate.replaceAll('.', '').replaceAll(',', '.'))
		)
	}, 0)

	calcList.forEach((calc) => {
		if (calc.type !== 'table') return
		tableTemplate.table.body.push([
			{
				text: calc.title,
			},
			{
				text: calc.savings === '0' ? '' : 'R$ ' + calc.savings,
				alignment: 'right',
			},
			{
				text: 'R$ ' + calc.recuperate,
				alignment: 'right',
			},
		])
	})

	tableTemplate.table.body.push([
		{ text: 'Total', style: 'tableHeader' },
		{
			text: 'R$ ' + currencyFormat(totalSavings),
			style: 'tableHeader',
			alignment: 'right',
		},
		{
			text: 'R$ ' + currencyFormat(total),
			style: 'tableHeader',
			alignment: 'right',
		},
	])

	return tableTemplate
}

function setUser(name, email, phone = '', obs = '') {
	user.name = name
	user.email = email
	user.phone = phone
	user.obs = obs
}

function setClient(company, name) {
	client.company = company
	client.name = name
}

function download(
	filename = 'Estimativa de Economia e Recuperação Tributária - Locatelli',
) {
	if (client.company) {
		filename =
			'Estimativa de Economia e Recuperação Tributária - ' +
			client.company +
			' - Locatelli'
	}

	window.pdfMake.createPdf(dd()).download(filename)
}

function dd() {
	const dd = {
		info: {
			title: 'Estimativa de Economia e Recuperação Tributária - Locatelli',
			author: 'Locatelli Adogados',
		},
		pageMargins: [30, 160, 30, 40],
		pageSize: {
			width: 290 * 3.2,
			height: 375 * 3.2,
		},
		images: {
			logo: window.location.origin + '/logo-locatelli.jpeg',
		},
		background: [
			{
				columns: [
					{
						image: 'logo',
						height: 140,
						width: 330,
					},
					{
						svg: '<svg width="600" height="140"><rect width="600" height="140" style="fill:#003e51;" /></svg>',
					},
				],
			},
			{
				columns: [
					{
						svg: '<svg width="1800" height="3"><rect width="1800" height="3" style="fill:#e94e24;" /></svg>',
					},
				],
			},
		],
		header: [
			{
				columns: [
					{ text: '', width: 330 },
					{
						stack: [
							{
								text: 'Estimativa de Economia e Recuperação Tributária',
								fontSize: 32,
								bold: true,
								color: '#fff',
								margin: [15, 25, 0, 5],
							},
							{
								text: new Date().toLocaleDateString('pt', {
									year: 'numeric',
									month: '2-digit',
									day: '2-digit',
								}),
								fontSize: 12,
								bold: true,
								color: '#fff',
								margin: [15, 0, 0, 0],
							},
						],
					},
				],
			},
		],
		content: [],
		styles: {
			tableExample: {
				margin: [0, 5, 0, 5],
				fontSize: 18,
			},
			tableHeader: {
				bold: true,
				fontSize: 21,
				color: 'black',
			},
			tableHeaderCompany: {
				bold: true,
				fontSize: 21,
				color: 'black',
				alignment: 'center',
			},
			icon: { font: 'icon', color: '#e94e24' },
			label: {
				bold: true,
				fontSize: 18,
			},
			labelHeader: {
				bold: true,
				fontSize: 21,
			},
			value: {
				fontSize: 21,
			},
			chartTitle: {
				bold: true,
				fontSize: 23,
			},
		},
	}

	const calcTypeTable = calcList.find((calc) => calc.type === 'table')

	if (calcTypeTable) {
		dd.content.push(getTable())
	}

	const calcTypeGrid = calcList.find((calc) => calc.type === 'grid')
	if (calcTypeGrid) {
		dd.content.push(...getGridList())
	}

	dd.content.push({
		columns: [
			/*
					{
						text: '',
						width: 'auto',
						margin: [0, 0, 10, 0],
					},
					{ text: user.email, width: 'auto', margin: [0, 0, 10, 0] },
					{ text: user.phone, width: 'auto' },
					*/
			{ text: '', width: '*' },
			{
				text: [
					{
						text: 'Conheça nossas redes ',
						alignment: 'right',
					},
					{
						text: '  ',
						link: 'https://locatelliadv.com.br/',
						style: 'icon',
					},
					{
						text: '  ',
						link: 'https://www.linkedin.com/company/locatelli-advogados-tributario',
						style: 'icon',
					},
					{
						text: '  ',
						link: 'https://www.instagram.com/locatelli_advogados/',
						style: 'icon',
					},
					{
						text: ' ',
						link: 'https://www.youtube.com/channel/UCR8L1Fe85xS1snTE2BLUaiQ',
						style: 'icon',
					},
				],
				margin: [0, 20, 0, 0],
			},
		],
		alignment: 'center',
		margin: [0, 0, 0, 5],
		fontSize: 15,
	})
	dd.content.push({
		text: 'Aviso Legal',
		fontSize: 20,
		margin: [0, 20, 0, 5],
	})
	dd.content.push({
		text: 'As informações constantes neste relatório são apenas indicativas e originadas de bases públicas disponibilizadas pelo Judiciário. Não utilizamos a base completa de dados dos processos e das empresas.',
	})

	return dd
}

export default {
	addCalc,
	clear,
	setUser,
	setClient,
	download,
}
